import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TicketService } from 'src/app/shared/customer/ticket/ticket.service';
import { LoginService } from 'src/app/shared/user-login/login.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from 'src/app/shared/customer/customer.service';
import { CurveService } from 'src/app/shared/curve-service/curve.service';
import { FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-get-tickets',
    templateUrl: './get-tickets.component.html',
    styleUrls: ['./get-tickets.component.css'],
    standalone: false
})
export class GetTicketsComponent implements OnInit {
  tickets: []
  role: string
  serverErrorMessages: string
  closeResult: string;
  messages: any[] = [];
  ticketID
  rate=4
  environment
  attachments
  graphDetails;
  feedbackID;
  customerMessage : string;
  isOpen=false;
  feedbackMessage : string;
  file: File;
  imageUrl: string | ArrayBuffer = "";
  fileName: string = "No file selected";
  constructor(private loginService: LoginService, private ticketService: TicketService, private modalService: NgbModal, private customerService: CustomerService, private router : Router, private datePipe: DatePipe,private curveService: CurveService) { }

  ngOnInit(): void {
    if (this.loginService.shouldBlock()) {
      alert('Low Balance! Redirecting...');
      this.router.navigateByUrl('/home');
    }
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          // this.loading = false;
          this.getAllTickets();
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          // this.loading = false;
        }
      )
    }
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  getAllTickets(){
    this.ticketService.getAllTickets().subscribe(
      res => {
        this.tickets = res['tickets'].reverse();
       console.log('Got tickets', this.tickets);


      },
      err => {
       //console.log('Error getting tickets', err)
        this.serverErrorMessages = err.error.message;
      }
    )
  }

  open(content, messages, ticketID,isOpen) {
    ////console.log(content, typeof(content))
    this.messages = messages;
    console.log(isOpen);
    if(isOpen == true)
    {
      this.isOpen = true;
    }
    else if(isOpen==false)
    {
      this.isOpen= false;
    }
    this.ticketID = ticketID;
   //console.log(messages)
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {

      this.closeResult = `Closed with: ${result}`;
     //console.log(this.closeResult)
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     //console.log(this.closeResult)
    });
  }


  openattachment(content) {
    ////console.log(content, typeof(content))

       //console.log(messages)
       if(this.file)
       {
         alert("Attachments already added! To add a new attachment, send the current message and type a new one.")
       }
       else{
        this.modalService.open(content, {ariaLabelledBy: 'modal-attachment-title'}).result.then((result) => {

          this.closeResult = `Closed with: ${result}`;
         //console.log(this.closeResult)
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
         console.log(this.closeResult)
         console.log(this.file,this.fileName,this.imageUrl)
        });
       }

  }

  openAllAttachments(content,ticket_id)
  {
    this.environment = environment;
    this.ticketService.getAllAttachments({ticketID: ticket_id}).subscribe(
      res => {
        this.attachments = res['attachments'];
       console.log('Got attachments', this.attachments);
      //  this.tickets.reverse();
      //  console.log(this.tickets);
      // console.log("file:",this.attachments[0].file);
        console.log(this.attachments.length)
        this.modalService.open(content, {ariaLabelledBy: 'modal-view-attachment-title'}).result.then((result) => {

          this.closeResult = `Closed with: ${result}`;
         //console.log(this.closeResult)
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;

        });
      },
      err => {
       console.log('Error getting attachments', err)
        this.serverErrorMessages = err.error.message;
      }
    )




  }


  onChange(file: File) {
    if (file) {
      this.fileName = file.name;
      this.file = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = event => {
        this.imageUrl = reader.result;
        console.log(this.imageUrl)
      };

    }
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  sendCurveDataToAnalyser(id, heatNumber){
    this.curveService.getCurveDataById({curveId: id}).subscribe(res=>{
      ////console.log('got curve details', res);
      this.graphDetails = res['curveData'];
     //console.log(this.graphDetails)
      // this.curveService.changeCurve({dataPoints: this.graphDetails.dataPoints, thermalValues: this.graphDetails.thermalValues, derivatives:this.graphDetails.refinedDerivatives})
      let CP = this.graphDetails.thermalValues.CarbonPercentage
      let ACEL = this.graphDetails.thermalValues.ACEL
      let TES = this.graphDetails.thermalValues.TES

      if(CP <=0 || ACEL<=0 || TES<=0 || !CP || !ACEL || !TES)
        alert(" The curve you are about to view was marked as an incorrect sample and needs to be retaken. Press ok to continue.")

      this.curveService.changeCurve({dataPoints: this.graphDetails.dataPoints, thermalValues: this.graphDetails.thermalValues, derivatives:this.graphDetails.refinedDerivatives, paid:this.graphDetails.paid, curveID:id, heatNumber:"sample_heat_number"})
      this.curveService.changeCurve({dataPoints: this.graphDetails.dataPoints, thermalValues: this.graphDetails.thermalValues, derivatives:this.graphDetails.refinedDerivatives, paid:this.graphDetails.paid, curveID:id,heatNumber:heatNumber, heatId: this.graphDetails.heatId})
      // Heat id DISPLAYING   Changing date 13-04-2024  -- by Rajadurai
      this.router.navigateByUrl('analyze-curve');
    },
    err => {
     //console.log('got error', err)
    })
   //console.log('send data to analyzer')
  }

  closeTicket(ticketID, content) {
    this.feedbackID = ticketID;
    this.ticketService.closeTicket({ticketID: ticketID}).subscribe(
      res=>{
       //console.log('success', res);
        alert('Ticket Closed!');

        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
         //console.log(this.closeResult)
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
         //console.log(this.closeResult)
        });
      },
      err => {
       //console.log('error', err);
        alert('Error occurred');
      }
    )
  }

  replyToTicket(){
    if(!this.customerMessage)
    {
      alert("Blank messages cannot be sent.")
    }
    else
    {
      this.customerService.replyToTicket({customerMessage: this.customerMessage, ticketID: this.ticketID, role : "CUSTOMER"},this.file).subscribe(
        res => {
          console.log(res);
          alert(res['message']);
         // window.location.reload();
        },
        err => {
         alert(err)
        }
      )
    }
   //console.log(this.customerMessage, this.ticketID)

  }

  onLogout(){
    this.loginService.deleteToken();
    this.router.navigateByUrl('/signin');
  }

  transformDate(x){
    return(this.datePipe.transform(x, 'yyyy-MM-dd'));
  }

  sendFeedback() {
   //console.log(this.feedbackID, this.feedbackMessage, this.rate);
    this.ticketService.sendFeedback({ticketId: this.feedbackID, rating: this.rate, details: this.feedbackMessage }).subscribe(
      res=>{
       //console.log('feedback sent', res);
        alert('Feedback Sent');
        window.location.reload();
      },
      err => {
       //console.log('error', err);
        alert('Error occurred while sending feedback.');
      }
    )
  }
}

